import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    GetClosedLeadFollowupAutomation as GetClosedLeadFollowupAutomationQuery,
    GetClosedLeadFollowupAutomation_closedLeadFollowupAutomation as ClosedLeadFollowupAutomation,
    GetClosedLeadFollowupAutomationVariables,
    FollowupLeadAutomationInput,
} from 'nutshell-graphql-types';

import GET_CLOSED_LEAD_FOLLOWUP_AUTOMATION from '../queries/get-closed-lead-followup-automation.graphql';

export const useGetClosedLeadFollowupAutomation = (
    input: FollowupLeadAutomationInput
): {
    closedLeadFollowupAutomation: ClosedLeadFollowupAutomation | null | undefined;
    isLoading: boolean;
    error: string | null | undefined;
    refetch: () => Promise<any>;
} => {
    const {loading, data, error, refetch} = useQuery<
        GetClosedLeadFollowupAutomationQuery,
        GetClosedLeadFollowupAutomationVariables
    >(GET_CLOSED_LEAD_FOLLOWUP_AUTOMATION, {
        variables: {
            input,
        },
        skip: !input.automationId,
    });

    return {
        closedLeadFollowupAutomation: data && data.closedLeadFollowupAutomation,
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
        refetch,
    };
};
